module.exports = function() {
  return new Worker(__webpack_public_path__ + "debfa083ecaf1899ffd9.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/worker-loader/dist/cjs.js!./~/pdfjs-dist/es5/build/pdf.worker.js
// module id = 1081
// module chunks = 1